import React, { useState, useEffect } from "react";
import _ from "lodash";

import FluserUser from "../components/FluserUser";

import { dotted_line } from "../../../assets/images/fluster";
import { question_marks } from "../../../assets/images/fluster";
import { all_button } from "../../../assets/images/fluster";
import { one_arrow } from "../../../assets/images/fluster";
import { two_arrow } from "../../../assets/images/fluster";
import { three_arrow } from "../../../assets/images/fluster";
import { AroundTheHornQuestion } from "../../../assets/images/fluster";
import { quesPoint1 } from "../../../assets/images/fluster";
import { quesPoint2 } from "../../../assets/images/fluster";
import { quesPoint3 } from "../../../assets/images/fluster";

const Question = ({
  parameters,
  status,
  answerer_player_details,
  asker_player_details,
  question,
  timer,
  onTimesUp,
  voteArray,
  questionPoint,
}) => {
  const [exclamationOne, setexclamationOne] = useState(0);
  const [exlamationTwo, setexlamationTwo] = useState(0);
  const [exclamationThree, setexclamationThree] = useState(0);
  const info_1 = _.get(parameters, "4_question.info_1", "is answering");
  const info_2 = _.get(parameters, "4_question.info_2", "VOTE NOW!");
  const aroundthehornquestion_info = _.get(
    parameters,
    "9_aroundthehornquestion.info",
    "AROUND THE HORN"
  );
  const answerer_display_name = _.get(answerer_player_details, "display_name");
  const answerer_profile_image = _.get(
    answerer_player_details,
    "profile_image"
  );
  const asker_display_name = _.get(asker_player_details, "display_name");
  const asker_profile_image = _.get(asker_player_details, "profile_image");

  const [countdown, set_countdown] = useState(timer);

  const get_points_image = (questionPoint) => {
    switch (questionPoint) {
      case 1:
        return (
          <>
            {" "}
            <img src={quesPoint1} />
          </>
        );
      case 2:
        return (
          <>
            {" "}
            <img src={quesPoint2} />
          </>
        );
      case 3:
        return (
          <>
            {" "}
            <img src={quesPoint3} />
          </>
        );
    }
  };

  useEffect(() => {
    if (countdown > 0) {
      setTimeout(() => set_countdown(countdown - 1), 1000);
    } else {
      if (status !== "AroundTheHornQuestion") {
        onTimesUp();
      }
    }
  }, [countdown]);

  useEffect(() => {
    let count1 = 0;
    let count2 = 0;
    let count3 = 0;
    voteArray &&
      voteArray.length > 0 &&
      voteArray.forEach((vot, i) => {
        if (vot?.points === 3) {
          count3++;
        } else if (vot?.points === 2) {
          count2++;
        } else {
          count1++;
        }
      });
    setexclamationOne(count1);
    setexlamationTwo(count2);
    setexclamationThree(count3);
  }, [JSON.stringify(voteArray)]);

  return (
    <div className="fluster-question">
      <div className="top-content">
        <div className="left-content">
          <div className="dotted-bg">
            <p>{question?.question}</p>
            {get_points_image(questionPoint)}
          </div>
        </div>
        <div className="middle-content">
          <img src={dotted_line} alt="" />
        </div>
        <div className="right-content">
          {status === "AroundTheHornQuestion" ? (
            <div className="around_the_horn_text">
              <p>{aroundthehornquestion_info}</p>
              <img src={AroundTheHornQuestion}></img>
            </div>
          ) : (
            <>
              <div className="users-images">
                <div className="userimg-content">
                  {status === "FlusterQuestion" ? (
                    <FluserUser
                      display_name={asker_display_name}
                      profile_image={asker_profile_image}
                    />
                  ) : (
                    <FluserUser
                      display_name={answerer_display_name}
                      profile_image={answerer_profile_image}
                    />
                  )}
                </div>
                <div className="voting-content">
                  <h3 className="answer">{info_1}</h3>
                  <h4 className="vote"> {info_2}</h4>
                </div>
              </div>
              <div className="vote-content">
                <div className="d-flex align-items-center mr-3">
                  <h5>{exclamationOne} x</h5>
                  <img src={one_arrow}></img>
                </div>
                <div className="d-flex align-items-center mr-3">
                  <h5>{exlamationTwo} x</h5>
                  <img src={two_arrow}></img>
                </div>
                <div className="d-flex align-items-center mr-3">
                  <h5>{exclamationThree} x</h5>
                  <img src={three_arrow}></img>
                </div>
              </div>

              <div className="timer-section">
                <img src={all_button} alt="" className="user-border" />
                <h3>{`${Math.floor(countdown / 60)
                  .toString()
                  .padStart(2, 0)} : ${Math.floor(countdown % 60)
                  .toString()
                  .padStart(2, 0)}`}</h3>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Question;
